export enum SymbolTypes {
  CRYPTO = 'Cryptocurrency',
  STOCKS = 'Stock',
  INDEX = 'Index',
  ETF = 'ETF',
}
